import {
  AI_AUTOPILOT_USER_ID,
  CHATBOT_USER_ID,
} from "@redotech/ai-autopilot-constants/constant";
import { MongoUserId } from "@redotech/effect-api-shared/ids/mongo-ids";
import type { ConversationListItemResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";
import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import type { GetUser as User } from "@redotech/redo-model/user";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";

interface EditableAssigneeCellProps {
  conversation: ConversationListItemResponse;
}

function getAssigneeDisplayName(user: User): string {
  if (user._id === CHATBOT_USER_ID) {
    return "Chatbot";
  }
  if (user._id === AI_AUTOPILOT_USER_ID) {
    return "AI Autopilot";
  }
  return user.name;
}

export const EditableAssigneeCell = memo(function EditableAssigneeCell({
  conversation,
}: EditableAssigneeCellProps) {
  const team = useRequiredContext(TeamContext);

  const assigneeName = useMemo(() => {
    const { mongoAssigneeId } = conversation;
    if (!mongoAssigneeId) {
      return "Unassigned";
    }
    const hexId = MongoUserId.toObjectId(mongoAssigneeId).toHexString();
    const teamUser = team.users.find(
      (u) => typeof u.user === "object" && u.user._id === hexId,
    );
    const user =
      teamUser && typeof teamUser.user === "object"
        ? (teamUser.user as User)
        : undefined;
    if (!user) {
      return "Unknown";
    }
    return getAssigneeDisplayName(user);
  }, [conversation, team.users]);

  return (
    <Text fontSize="xs" textColor="tertiary">
      {assigneeName}
    </Text>
  );
});
